// Clase: "Func", con métodos básicos y generales para el funcionamiento del sitio.
var Bioproductos = {
    init: function () {
        $('#bioproductos-header-toggle').on('click', function (e) {
            Bioproductos.toggleHeader();
        });

        Bioproductos.verifyTopScroll();

        $('#faq').on('click', '.question', (event) => {
            event.preventDefault();
            Bioproductos.toggleAnswer(event.target);
            event.stopPropagation();
        });

        Bioproductos.installCountdown('#bioproductos-countdown');
    },
    installCountdown: function(selector) {
        let date = $(selector).data('countdown-date');
        var nextYear = moment.tz(date, "YYYY-M-D H:m", "Etc/GMT-6");
        
        $(selector).countdown(nextYear.toDate(), function(event) {
            $(this).children('.days').html(event.strftime('%D días'));
            $(this).children('.time').html(event.strftime('%H:%M:%S'));
        });
    },
    toggleAnswer: function(elem) {
        var el = $(elem);
        var directAnswer = el.siblings('.answer').first();
        var items = el.parent('.item').siblings('.item');

        items.each(function(){
            var answer = $(this).find('.answer').first();
            if(answer.hasClass('active')) {
                answer.removeClass('active');
            }
        });
        directAnswer.toggleClass('active');
    },
    toggleHeader: function () {
        var h = $('#bioproductos-header');

        if (!h.hasClass('active')) {
            h.addClass('active');
        } else {
            h.removeClass('active');
        }
    },
    verifyTopScroll: function() {
        var top = $(window).scrollTop();
        var header = $('#bioproductos-header');

        if (!header.hasClass('scrolling')) {
            if (top > 40) {
                header.addClass('scrolling');
            }
        } else {
            if (top < 40) {
                header.removeClass('scrolling');
            }
        }
    }
};

// Inicializador
$(function () {
    Bioproductos.init();
});
$(window).on('scroll', function () {
    Bioproductos.verifyTopScroll();
});
$(window).resize(function () { });
